/**
 * @author liwensheng
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DOM_LAYER_CLASS } from '../constant';
import Shape from './Shape';
import { inBBox, createZeroBBox } from '../utils/bbox';
import { getDOMRenderer } from '../utils/dom-renderer';
var shapeKeys = [
    'x',
    'y',
    'text',
    'fontSize',
    'fontFamily',
    'textAlign',
    'textBaseline',
    'fontWeight',
];
var DOMNode = /** @class */ (function (_super) {
    __extends(DOMNode, _super);
    function DOMNode() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'dom';
        _this.fillAble = false;
        _this.strokeAble = false;
        _this.shapeKeys = shapeKeys;
        _this._contentDirty = true;
        return _this;
    }
    DOMNode.prototype.getDefaultAttr = function () {
        return __assign(__assign({}, _super.prototype.getDefaultAttr.call(this)), { x: 0, y: 0, textAlign: 'left', textBaseline: 'top', renderer: 'html' });
    };
    DOMNode.prototype.mounted = function () {
        _super.prototype.mounted.call(this);
        if (!this._container) {
            this._container = document.createElement('div');
            this._container.className = DOM_LAYER_CLASS;
        }
        if (this.ownerRender) {
            this.ownerRender.getDom().appendChild(this._container);
            this.update();
        }
    };
    DOMNode.prototype.update = function () {
        var _this = this;
        var container = this._container;
        if (!container) {
            return;
        }
        this._renderer = getDOMRenderer(this.attr.renderer);
        var fontSize = this.getExtendAttr('fontSize') + 'px';
        var fontFamily = this.getExtendAttr('fontFamily');
        var fill = this.getExtendAttr('fill');
        var fontWeight = this.getExtendAttr('fontWeight');
        var pointerEvents = this.getExtendAttr('pointerEvents');
        var cursor = this.getExtendAttr('cursor');
        var textAlign = this.getExtendAttr('textAlign');
        var textBaseline = this.getExtendAttr('textBaseline');
        var cssStyle = {
            lineHeight: '100%',
            position: 'absolute',
            fontSize: fontSize,
            fontFamily: fontFamily,
            color: fill,
            fontWeight: fontWeight + '',
            pointerEvents: pointerEvents,
            cursor: cursor
        };
        for (var key in cssStyle) {
            container.style[key] = cssStyle[key];
        }
        container.style.display = this.attr.display === false ? 'none' : 'block';
        container.style.textAlign = textAlign;
        this._setTransform();
        if (textAlign === 'left') {
            container.style.left = this.attr.x + 'px';
            container.style.right = 'auto';
        }
        else if (textAlign === 'right') {
            container.style.left = 'auto';
            container.style.right = (this.ownerRender.getWidth() - this.attr.x) + 'px';
        }
        if (textBaseline === 'top') {
            container.style.top = this.attr.y + 'px';
            container.style.bottom = 'auto';
        }
        else if (textBaseline === 'bottom') {
            container.style.top = 'auto';
            container.style.bottom = (this.ownerRender.getHeight() - this.attr.y) + 'px';
        }
        if (textAlign === 'center' || textBaseline === 'middle') {
            requestAnimationFrame(function () {
                var width = container.clientWidth;
                var height = container.clientHeight;
                if (textAlign === 'center') {
                    container.style.left = (_this.attr.x - width / 2) + 'px';
                }
                if (textBaseline === 'middle') {
                    container.style.top = (_this.attr.y - height / 2) + 'px';
                }
            });
        }
        if (this._contentDirty) {
            this._renderer.update(container, this.attr.text);
        }
        this._contentDirty = false;
    };
    DOMNode.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        this._renderer.destroy(this._container);
        this._container.parentNode.removeChild(this._container);
    };
    DOMNode.prototype.dirtyGlobalTransform = function () {
        _super.prototype.dirtyGlobalTransform.call(this);
        this._setTransform();
    };
    DOMNode.prototype.getContainer = function () {
        return this._container;
    };
    DOMNode.prototype.onAttrChange = function (attr, value, oldValue) {
        _super.prototype.onAttrChange.call(this, attr, value, oldValue);
        if (attr === 'text') {
            this._contentDirty = true;
        }
    };
    DOMNode.prototype.isPointOnPath = function (x, y) {
        return inBBox(this.getBBox(), x, y);
    };
    DOMNode.prototype.computeBBox = function () {
        if (!this._container) {
            return createZeroBBox();
        }
        var _a = this.attr, x = _a.x, y = _a.y;
        var textAlign = this.getExtendAttr('textAlign');
        var textBaseline = this.getExtendAttr('textBaseline');
        var textWidth = this._container.clientWidth;
        var textHeight = this._container.clientHeight;
        var bbox = {
            x: x,
            y: y,
            width: textWidth,
            height: textHeight,
        };
        if (textAlign === 'center') {
            bbox.x = x - textWidth / 2;
        }
        else if (textAlign === 'right') {
            bbox.x = x - textWidth;
        }
        if (textBaseline === 'top') {
            bbox.y = y;
        }
        else if (textBaseline === 'middle') {
            bbox.y = y - textHeight / 2;
        }
        else {
            bbox.y = y - textHeight;
        }
        return bbox;
    };
    DOMNode.prototype._setTransform = function () {
        var _a = this.attr, x = _a.x, y = _a.y;
        var container = this._container;
        if (!container) {
            return;
        }
        var textAlign = this.getExtendAttr('textAlign');
        var textBaseline = this.getExtendAttr('textBaseline');
        var matrix = this.getGlobalTransform();
        var transform = [matrix[0], matrix[1], matrix[3], matrix[4], matrix[6], matrix[7]];
        var originMap = {
            left: -x + "px",
            center: "calc(" + -x + "px + 50%)",
            right: "calc(" + -x + "px + 100%)",
            top: -y + "px",
            middle: "calc(" + -y + "px + 50%)",
            bottom: "calc(" + -y + "px + 100%)",
        };
        var cssMatrix = "matrix(" + transform.join(',') + ")";
        container.style.transform = cssMatrix;
        container.style.transformOrigin = originMap[textAlign] + " " + originMap[textBaseline];
    };
    return DOMNode;
}(Shape));
export default DOMNode;
